import React from 'react';
import classnames from 'classnames';
import { gikClassPrefix } from '@gik/core/constants';
import LoadingSpinner from '@gik/ui/LoadingSpinner';

export interface IPageLoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  loading: boolean;
}

export const blockName = `${gikClassPrefix}-page-loader`;

export default function PageLoader({
  children,
  loading,
  className,
  ...otherProps
}: IPageLoaderProps): React.ReactElement {
  const blockClasses = classnames([blockName, className || '']);

  if (loading)
    return (
      <div className={blockClasses} {...otherProps}>
        <LoadingSpinner />
      </div>
    );

  return <>{children}</>;
}
